const pathnames = {
	dashboard: "/",
	invoice: {
		createEdit: "/invoice/create-edit/",
		bulkUpload: "/invoice/bulk-upload",
	},
};

export default pathnames;
